import React, { Component } from 'react';
import API from "../../config/api";
import moment from 'moment';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import PopupImage from "../Bar/PopupImage";
import './../custom.css';
import CustomModal from "../Bar/CustomModal";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Link, Navigate, useNavigate } from "react-router-dom";
import Pagination from "../Bar/Pagination";


const modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    [{ color: [] }, { background: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    // ['link', 'image', 'video'],
    ['clean'],
  ],
};

export class TopicView extends Component {

    constructor(props) {
        super(props)
      
        this.state = {
          page: 1,
          total: 0,
          word_type: [],
          topic_id: null,
          name_khmer: '',
          name_korean: '',
          description: '',
          code: '',
          type: '',
          thumbnail: null,
          limit: 100,
          s: '',
          preview_thumbnail_progress: null,
          full_image_url: '',

          id: 1,
          quizs: [],
          all_categories: [],
          selected_categories: [],
          added_questions: [],

          data: [],
          percentage: 0,
          disable: true,
          // thumbnail: null,
          // image_url: "",
          // description: "",
          success: null,
          category_id: 1,
          categories: [],
          fields: {
            name: "",
            // description: ""
          },
          errors: {},
        }
        this.inputRefs = {
          name: React.createRef(),
          // description: React.createRef(),
        };
      }

      UNSAFE_componentWillMount() {
        this.getParam("id")
        // this.getParam("topic")
        this.getAllWordType();
        this.getImage();
      }

      getParam(name) {
        let id = window.location.search.split(`${name}=`)[1]
        if (name == "id") {
          this.state.id = id;
          this.setState({});
          this.getOneTopic();
        }
        // if (name == "topic") {
        //   this.state.topic_id = id;
        //   this.setState({});
        //   this.getOneTopic();
        // }

        // if (id) {
        //   this.getOneTopic();
        // }
      }
      getAllWordType = async () => {
        try {
          let query = `page=${this.state.page}&s=${this.state.s}&type=${this.state.id}&limit=${this.state.limit}`
          let results = await API.getAllWordType(query);
          let data = results.data;
          
          this.setState({ word_type : data.vocab_folders, total: data.total });
    
        } catch (error) {
          console.log(error)
        }
      }

      getImage() {
        let url = API.getImage();
        this.setState({image_url : url})
      }

      getOneQuestion = async (id) => {
        try {
          let query = `id=${id}`
          let results = await API.getOneQuestion(query);
    
          let data = results.data.quiz;
          this.state.added_questions.push(data)
          this.setState({})
        } catch (error) {
          console.log(error)
        }
      }
    
      getOneTopic = async () => {
        try {
          let query = `id=${this.state.id}`
          let results = await API.getOneTopic(query);
    
          let data = results.data;


          // let questions = [];
          // let get_question = data.vocab;
          // get_question.map(q => {
          //   questions.push(q)
          // })

          // this.setState({ 
          //   added_questions: questions,
          //   data : data, 
          //   code: data.code,
          //   description: data.description,
          //   name: data.name_khmer,
          //   thumbnail: data.thumbnail_url,
          //   full_image_url: data.full_thumbnail_url
          // });


          // this.state.added_questions = questions;
          this.state.data = data;
          this.state.code = data.code;
          this.state.type = data.type;
          this.state.description = data.description;
          this.state.name_khmer = data.name_khmer;
          this.state.name_korean = data.name_korean;
          this.state.fields.name = data.name_khmer;
          this.state.thumbnail = data.thumbnail_url;
          this.state.full_image_url = data.full_thumbnail_url;

          this.setState({});
    
        } catch (error) {
          console.log(error)
        }
      }

      // getAllClass = async () => {
      //   try {
      //     let query = `page=${this.state.page}&s=${this.state.s}&limit=${this.state.limit}`
      //     let results = await API.getAllClass(query);
      //     let data = results.data;
          
      //     this.setState({ quizs : data.class, total: data.total });
    
      //   } catch (error) {
      //     console.log(error)
      //   }
      // }

      onQuestionFourImageChange = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        
        try {
          let results = await API.adminUpload(
            formData,
            (percentage) => {
              this.state.preview_image_progress = percentage;
              this.setState({})
            }
          );
          if (results){
            this.state.preview_image_progress = 100;
            this.state.thumbnail = results.filename;
            this.state.full_image_url = results.full_url;
            this.setState({});
            // this.setState({ image_url: results.filename })
          }
    
        } catch (error) {
          toast.error("Oops! Something went wrong. Please try again.", {
            data: {
              title: "Success toast",
              text: "This is a success message",
            },
          })
          console.log(error)
        }
      }

      getAllWordList = async () => {
        try {
          let query = `page=${this.state.page}&s=${this.state.s}&limit=${this.state.limit}`
          let results = await API.getAllWordList(query);
          let data = results.data;
          
          this.setState({ quizs : data.vocabs, total: data.total });
    
        } catch (error) {
          console.log(error)
        }
      }

      onSearch = async (event) => {
        event.preventDefault();
        let value = event.target.value;
        this.state.s = value;
        this.setState({});
        this.getAllWordType();
      }

      onUploadProgress = (percentage) => {
        this.setState({ percentage: percentage})
        if (percentage ===100) {
          this.setState({ disable: false })
        }
      }

      onChangeFile = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        let name = event.target.name;
        const formData = new FormData();
        formData.append("file", file);
        
        try {
          let results = await API.adminUpload(
            formData,
            this.onUploadProgress
          );
          
          if (results){
            this.state.thumbnail = results.filename;
            this.state.full_thumbnail = results.full_url;
            // this.setState({ data: {
            //   ...this.state.data,
            //   [name]: results.filename,
            // }})
          }
    
        } catch (error) {
          console.log(error)
        }
      }

      validateFields = () => {
        const { fields } = this.state;
        const errors = {};
        let firstEmptyField = null;
    
        // Check for empty fields
        Object.keys(fields).forEach((field) => {
          if (!fields[field].trim()) {
            errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            if (!firstEmptyField) {
              firstEmptyField = field; // Record the first empty field
            }
          }
        });
    
        this.setState({ errors });
    
        // Focus on the first empty field
        if (firstEmptyField) {
          this.inputRefs[firstEmptyField].current.focus();
        }
    
        // Return true if no errors
        return Object.keys(errors).length === 0;
      }

      // handelInput = (event) => {
      //   event.preventDefault();
      //   let value = event.target.value;
      //   let name = event.target.name;
        
      //   this.setState({ data: {
      //     ...this.state.data,
      //     [name]: value
      //   }})
      // }
      deleteFolder = async (event) => {
        event.preventDefault();
        let data = {
          id : this.state.data.id
        }
        try {
          let results = await API.postDeleteWordType(data);
          
          if (results.result){
            toast.success("Your action is successful", {
              data: {
                title: "Success toast",
                text: "This is a success message",
              },
            })
            this.getAllWordType();
          }
    
        } catch (error) {
          console.log(error)
        }
      }

      handelInput = (event) => {

        const { name, value } = event.target;
        this.setState((prevState) => ({
          fields: {
            ...prevState.fields,
            [name]: value,
          },
          errors: {
            ...prevState.errors,
            [name]: "", // Clear error for the field being updated
          },
        }));
      }
      
      onRemoveQuestion(data){
        this.state.added_questions.splice(this.state.added_questions.indexOf(data), 1);
        // this.state.quizs.push(data)
        // toast.success("Your action is successful", {
        //   data: {
        //     title: "Success toast",
        //     text: "This is a success message",
        //   },
        // })
        this.setState({})
    
      }

      onAddQuestion(data  = {}) {
        data.new = true;
        this.state.added_questions.unshift(data);
        
        // this.state.added_questions.push(data)
        // this.state.quizs.splice(this.state.quizs.indexOf(data), 1)

        // toast.success("Your action is successful", {
        //   data: {
        //     title: "Success toast",
        //     text: "This is a success message",
        //   },
        // })
        this.setState({})
      }

      onPaginationPress = (page) => {
        this.state.page = page;
        // this.setState({ page : page})
        this.getAllWordType();
        this.setState({})
      }
    
      handleSubmit = async (event) => {
        event.preventDefault();
        // if (!this.validateFields()) return

        // let quis_id = [];
        let quiz_id = this.state.added_questions.map(quiz => {
          return quiz.id
        });

         let data = {
          id: this.state.id,
          name_khmer: this.state.name_khmer,
          name_korean: this.state.name_korean,
          description: this.state.description,
          code: this.state.code,
          type: this.state.type,
          thumbnail_url: this.state.thumbnail,
          vocab_id: JSON.stringify(quiz_id)
         }

        // this.state.data.quiz_id = JSON.stringify(quiz_id)
        
        try {
          let results = await API.postOneTopic(data);
          if (results){
            this.state.id = results.data.id;
            this.setState({});
            toast.success("Your action is successful", {
              data: {
                title: "Success toast",
                text: "This is a success message",
              },
            })
            
            
            // this.setState({ success: results.result })
          }
    
        } catch (error) {
          console.log(error)
        }
      }

      linkToNewPage= async (id) => {
        let element = document.getElementById(`clickview${id}`);
        element.click();
      }

  render() {
    const { fields, errors } = this.state;
    return (
        <div className="col-12">
          <ToastContainer />
          {this.state.success && (
            <Navigate to={`/wordtypeview?id=${this.state.id}`} replace={true} />
            // <Navigate to="/topicindex?success=true" replace={true} />
        )}
            <form className="card" onSubmit={this.handleSubmit}>
            {/* <div className="card-title" >
              <h4>Type List by Topic: </h4>
             

            </div> */}

                {/* <div className="card-body row">
                  
                  
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Name Korean</label>
                      <ReactQuill 
                      theme="snow" 
                      modules={modules}
                      style={{"height" : "150px", marginTop: 10}} 
                      value={this.state.name_korean} 
                      onChange={(value) => {
                        this.state.name_korean = value;
                        this.setState({})
                      }}  
                      />
                      <br /><br />
                      <br />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Name Khmer</label>
                      <ReactQuill 
                      theme="snow" 
                      modules={modules}
                      style={{"height" : "150px", marginTop: 10}} 
                      value={this.state.name_khmer} 
                      onChange={(value) => {
                        this.state.name_khmer = value;
                        this.setState({})
                      }}  
                      />
                      <br /><br />
                    </div>
                  </div>


                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Description</label>
                        <input className="form-control" type="text" value={this.state.description} name='description' onChange={(event) => {
                          this.state.description = event.target.value;
                          this.setState({})
                        }} />
                      </div>
                    </div>
                </div> */}


                <h4 className="card-title"><strong>Type List by Topic</strong></h4>
                {
                  this.state.id && <div>
                    
                      <div className="card-body row">

                          <div className="col-md-12">



                          <div className="card-body">

                        <div className="flexbox mb-20">
                            <div className="lookup">
                              <input className="w-200px" type="text" name="s" placeholder="Search" onChange={this.onSearch} />
                            </div>

                            <div className="btn-toolbar">
                              <div className="btn-group btn-group-sm">
                              {/* <Select
                                required
                                styles={{
                                  menu: provided => ({ ...provided, zIndex: 9999 }),
                                  control: (base, state) => ({
                                    ...base,
                                    '&:hover': { borderColor: '#4ed2c5' },
                                    '&:focus': {
                                      borderColor: '1px solid #4ed2c5',
                                      // boxShadow: '0px 0px 6px #4ed2c5',
                                    },
                                    border: '1px solid #4ed2c5',
                                    borderColor: state.isFocused ? '#4ed2c5' : '#ebebeb',
                                    boxShadow: 'none',
                                    width:'200px',
                                }),
                                }}
                                defaultValue={{
                                  value: 0,
                                  label: 'All',
                                  id: 0
                                }}
                                isMulti={this.state.isMulti}

                                name="options"
                                options={this.state.all_categories}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                
                                onChange={value => {
                                  this.getOneCategory(value.id);
                                  this.setState({selected_tag: value})
                                  
                                }}
                              /> */}

                                {/* <button className="btn" title="Refresh" data-provide="tooltip"><i class="ion-refresh"></i>  </button> */}
                                {/* <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i></button> */}
                                <Link to="/wordtypeindex" ><button className="btn btn-info" title="View All Type" data-provide="tooltip">All Type <i class="fa fa-server"></i></button></Link>
                                &emsp;<Link to="/wordlistindex" ><button className="btn btn-success" title="View All List" data-provide="tooltip">All List <i class="fa fa-file-word-o"></i></button></Link>
                                &emsp;<Link to={`/wordtypeedit?topic=${this.state.id}`} > <button className="btn btn-primary" title="Add new" data-provide="tooltip"> <i className="ion-plus-round"></i></button></Link>
                                
                                {/* <Link to="/user/new" > <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i>New</button></Link> */}
                              </div>

                              {/* <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
                                <button className="btn dropdown-toggle" data-toggle="dropdown">Type</button>
                                <div className="dropdown-menu dropdown-menu-right">
                                  
                                  <a className="dropdown-item" href="/">All</a>
                                  <a className="dropdown-item" href="/">Reading</a>
                                  <a className="dropdown-item" href="/">Listioning</a>
                                </div>
                              </div> */}
                              </div>
                            </div>
                          <div>
                        </div>
                      </div>

                      {/* <div className="table-container" > */}
                            <table className="table table-hover table-has-action">
                            {/* <table className="fixed-header-table"> */}

                              <thead>
                                <tr>
                                  <th>#</th>
                                  {/* <th>Thumbnail</th> */}
                                  <th className="text-center w-150px">Name korean</th>
                                  {/* <th>Question</th> */}
                                  <th className="text-center w-150px">Name Khmer</th>
                                  <th className="text-center ">Description</th>
                                  <th>Topic</th>
                                  <th>Created Date</th>
                                  <th className="text-center w-150px">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                              {
                                this.state.word_type && this.state.word_type.map((type, index)=> {
                                  // quiz style

                                  // let add_id = this.state.added_questions.map(q => q.id);

                                  // let style = {};

                                  // let added = false;

                                  // if (add_id.includes(quiz.id)) {
                                  //   style = {background: '#d9d9d9'};
                                  //   added = true;
                                  // }

                                  return <tr >
                                    <th onClick={() => this.linkToNewPage(type.id)} scope="row">{( (this.state.page - 1) * 10) + (index+ 1)} </th>
                                    {/* <td>
                                      <div class="media">
                                        <img class="avatar" src={quiz.full_image_url ? quiz.full_image_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                                        <div class="media-body">
                                        </div>
                                      </div>
                                    </td> */}
                                    <td onClick={() => this.linkToNewPage(type.id)} style={{paddingTop: 20}}><strong dangerouslySetInnerHTML={{ __html: type.name_korean }}></strong></td>
                                    <td onClick={() => this.linkToNewPage(type.id)} style={{paddingTop: 20}}><strong dangerouslySetInnerHTML={{ __html: type.name_khmer }}></strong></td>
                                    <td onClick={() => this.linkToNewPage(type.id)} className="text-center "> <strong>{type.description}</strong></td>
                                    {/* <td className="w-100px">{quiz.code}</td> */}

                                    {/* <td className="w-100px">{this.state.all_categories.map((category, index) => {
                                      if(category.id === quiz.category_id) {
                                        return category.value.name
                                      }
                                      
                                    })}</td> */}
                                    <td onClick={() => this.linkToNewPage(type.id)} style={{paddingTop: 20}}><strong dangerouslySetInnerHTML={{ __html: this.state.name_khmer }}></strong></td>

                                    <td onClick={() => this.linkToNewPage(type.id)}>{moment(type.created_at).format("DD-MMM-YYYY")}</td>
                                    <td className="text-center table-actions">
                                      <Link title='View' class="btn btn-square btn-round btn-primary" id={`clickview${type.id}`} to={`/wordtypeview?id=${type.id}`}><i class="fa fa-eye"></i></Link>
                                      <span>&nbsp;</span><Link title='Edit' class="btn btn-square btn-round btn-info" to={`/wordtypeedit?id=${type.id}`}><i class="ti-pencil"></i></Link>
                                      <span>&nbsp;</span><Link title='Delete' class="btn btn-square btn-round btn-danger"><i data-toggle="modal" data-target="#modal-center" onClick={() => this.setState({data: type})} class="fa fa-trash"></i></Link>
                                      {/* <button className="btn btn-square  btn-primary"  onClick={() => this.onAddQuestion(type)}><i className="fa fa-plus" ></i></button> */}
                                      {/* <span>&nbsp;</span><Link className="btn btn-square btn-round btn-info" title="Edit" to={`/questionedit?id=${quiz.id}`}><i className="ti-pencil"></i></Link>
                                    
                                      <span>&nbsp;</span><Link title="Delete" onClick={() => this.setState({data: quiz})} className="btn btn-square btn-round btn-danger"><i className='ti-trash' data-toggle="modal" data-target="#modal-center" ></i> </Link> */}
                                    </td>
                                  </tr>
                                  
                                })
                              }
                              </tbody>
                            </table>
                            {/* <Pagination 
                              onPaginationPress = {this.onPaginationPress}
                              totalPageLength = {this.state.total}
                              selectPage = {this.state.page}
                            /> */}
                          {/* </div> */}
                          </div>
                      </div>    
                  </div>
                }

                <footer className="card-footer text-right">
                    <Link className="btn btn-secondary" to="/topicindex">Back</Link>
                    {/* <button className="btn btn-primary" type="submit">Submit</button> */}
                </footer>
                
            </form>
            
            {
              this.state.data &&
              <CustomModal 
                data={ this.state.data }  
                title="Do you really want to delete this topic?"
                deleteQuiz = {this.deleteFolder}
              />
           }
        </div>
    )
  }
}

const MyComponentWithNavigate = () => {
  const navigate = useNavigate();
  return <TopicView navigate={navigate} />;
};

export default MyComponentWithNavigate